<template>
  <v-expansion-panels v-model="filtersExpanded">
    <v-expansion-panel>
      <v-expansion-panel-header>
        {{ $t('global.filters') }}

        <template slot="actions">
          <v-icon large>mdi-filter-variant</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div v-on:keyup.enter="handleFilter">
          <slot name="filter" ></slot>
        </div>

        <v-btn color="primary" @click="handleFilter">{{ $t('global.filters')}}</v-btn>
        <v-btn color="primary" class="ml-2" text @click="handleReset">{{ $t('global.reset')}}</v-btn>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'DataFilter',
  props: {
    handleReset: {
      type: Function,
      required: true
    },
    handleFilter: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      filtersExpanded: false
    };
  }
};
</script>
